module.exports = __webpack_public_path__ + "static/media/03-6WHEELS_STALL.3da52ca2.png";